/**
 * CanvasTexture slice types: a canvas item's diffuse, normal and specular maps and the sampler they
 * share (`scene/main/canvas_item.h:428-480`). No THREE.
 */
/** The `type` a CanvasTexture sub-resource declares. */
export const CANVAS_TEXTURE_TYPE = 'CanvasTexture';
//# sourceMappingURL=types.js.map